import { API_HOST } from '../index.js';

async function apiFetch(path, options = {}) {
    const response = await fetch(`${API_HOST}${path}`, {
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...(options.headers || {})
        },
        ...options
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        const error = new Error(data.error || `Request failed (${response.status})`);
        error.status = response.status;
        error.data = data;
        throw error;
    }
    return data;
}

export function fetchMe() {
    return apiFetch('/auth/me');
}

export function fetchMyApps() {
    return apiFetch('/auth/me/apps');
}

export function adminListSoftware() {
    return apiFetch('/admin/software');
}

export function adminCreateSoftware(body) {
    return apiFetch('/admin/software', { method: 'POST', body: JSON.stringify(body) });
}

export function adminUpdateSoftware(id, body) {
    return apiFetch(`/admin/software/${id}`, { method: 'PATCH', body: JSON.stringify(body) });
}

export function adminUploadLogo(id, body) {
    return apiFetch(`/admin/software/${id}/logo`, { method: 'POST', body: JSON.stringify(body) });
}

export function adminSetInstitutionAccess(institutionId, softwareId, enabled) {
    return apiFetch(`/admin/institutions/${institutionId}/access`, {
        method: 'PATCH',
        body: JSON.stringify({ softwareId, enabled })
    });
}

export function adminListGrants(softwareId) {
    const q = softwareId ? `?softwareId=${encodeURIComponent(softwareId)}` : '';
    return apiFetch(`/admin/grants${q}`);
}

export function adminCreateGrant(body) {
    return apiFetch('/admin/grants', { method: 'POST', body: JSON.stringify(body) });
}

export function adminRevokeGrant(id) {
    return apiFetch(`/admin/grants/${id}`, { method: 'DELETE' });
}

export function adminListOrgUnits(q = '') {
    const query = q ? `?q=${encodeURIComponent(q)}` : '';
    return apiFetch(`/admin/org-units${query}`);
}

export function adminSyncDirectory() {
    return apiFetch('/admin/directory/sync', { method: 'POST', body: '{}' });
}

export function adminSyncState() {
    return apiFetch('/admin/directory/sync-state');
}

export function adminSearchUsers(q) {
    return apiFetch(`/admin/users/search?q=${encodeURIComponent(q)}`);
}

export function adminAccessPreview(email) {
    return apiFetch(`/admin/access/preview?email=${encodeURIComponent(email)}`);
}

export function adminAuditLogs(entityType = '') {
    const q = entityType ? `?entityType=${encodeURIComponent(entityType)}` : '';
    return apiFetch(`/admin/audit-logs${q}`);
}
